export default "__VITE_ASSET__Dca731vD__"